module.exports = "<svg viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"6\" cy=\"6\" r=\"1.5\" fill=\"currentColor\"></circle></svg>"